import React from 'react';
import { connect } from 'react-redux';
import { setUnreadNotificationCount, setWidget, unsetWidget } from '../store/actions';

import Header from '../components/common/Header';
import SideBar from '../components/common/SideBar';

import HomeSlider from '../components/common/HomeSlider';
import HomeLinks from '../components/common/HomeLinks';
import HomeWishes from '../components/common/HomeWishes';
import { ContentWrapper } from '../components/common/GlobalElements/Wrappers';

/** map actions */
function mapDispatchToProps(dispatch) {
    return {
        setUnreadNotificationCount: (payload) => dispatch(setUnreadNotificationCount(payload)),
        setWidget: (payload) => dispatch(setWidget(payload)),
        unsetWidget: (payload) => dispatch(unsetWidget()),
    };
}

/** map state */
const mapStateToProps = (state) => ({ notification: state.notification, user: state.user, widget: state.widget });

class HomePage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let user = this.props.user;
        let widget = this.props.widget;

        if (user && Object.keys(user).length > 0 && widget && Object.keys(widget).length > 0) {
        }

        const unreadNotificationCount = localStorage.getItem('unreadNotificationCount');
        this.props.unsetWidget();
        this.props.setWidget({ status: 2 });
        this.props.setUnreadNotificationCount(unreadNotificationCount ? unreadNotificationCount : 0);
    }

    render() {
        return (
            <>
                <Header></Header>
                <ContentWrapper>
                    <SideBar></SideBar>
                    <div className="sidebar-right">
                        <div className="home-list-wrap">
                            <HomeWishes />
                            <HomeSlider></HomeSlider>
                            <HomeLinks></HomeLinks>
                        </div>
                    </div>
                </ContentWrapper>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
